import { useAppSelector } from '../../../hooks/redux';
import { LightBulbIcon } from '../../../icons/SvgIcons';

type TutorialBannerProps = {
  onStartTour?: () => void;
  onDismiss?: () => void;
};

export function TutorialBanner({
  onStartTour,
  onDismiss
}: TutorialBannerProps) {
  const { showTutorialBanner } = useAppSelector((state) => state.tutorialGuide);

  if (!showTutorialBanner) return null;

  return (
    <div
      className="m-[2px] py-4 px-2 min-[1536px]:p-4 min-[1536px]:m-2 shadow-lg rounded-lg flex flex-col gap-4 items-center min-[1536px]:items-stretch"
      style={{
        background: 'linear-gradient(255deg, #55E6C1 1.03%, #3B3B98 99.99%)'
      }}
    >
      <div className="w-full flex flex-col gap-1 items-center min-[1536px]:items-start min-[1536px]:text-left">
        <div className="flex justify-center items-center gap-2 w-10 h-10 bg-purple-800 rounded-lg">
          {LightBulbIcon()}
        </div>
        <p className="hidden min-[1536px]:block text-md font-semibold text-white leading-6">
          Explore the platform with a quick tour.
        </p>
      </div>
      <div className="w-full flex flex-col gap-1 items-center min-[1536px]:items-stretch">
        <button
          onClick={onStartTour}
          className="text-xs font-medium text-purple-700 leading-5 bg-white rounded-full px-[11px] py-[7px] w-auto min-[1536px]:w-full"
        >
          Start Tour
        </button>
        <button
          onClick={onDismiss}
          className="text-xs font-medium text-white leading-5 rounded-full px-[11px] py-[7px] w-auto min-[1536px]:w-full"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
